<div class="content flex">
    <a href="javascript:;" (click)="goBack()" class="govuk-back-link">Back</a>
    <h1 class="govuk-heading-xl page-title">
        Confirm your organisation's details</h1>
    <app-cii-org-details></app-cii-org-details>
</div>